import { ContainerModule } from "inversify";
import * as Api from "@/app/interaction/api";
import { IncludeTableHandler } from './include-table-handler';

export const tableFactoryModule = new ContainerModule(bind => {
  bind<Api.IncludeComponentsHandlerInterface>(Api.IncludeComponentsHandlerSymbol).to(IncludeTableHandler);
});
